import { ReportTemplate } from '../types';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

interface ReportTemplateCardProps {
  template: ReportTemplate;
  onGenerate: (templateId: string) => void;
}

const ReportTemplateCard = ({ template, onGenerate }: ReportTemplateCardProps) => {
  return (
    <div className="bg-card rounded-md border border-border p-6 transition-interactive hover-scale">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-12 h-12 rounded-sm bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name={template.icon} size={24} color="var(--color-primary)" />
        </div>
        <div className="flex-1">
          <h4 className="text-base font-semibold text-foreground mb-1">
            {template.name}
          </h4>
          <p className="text-sm text-muted-foreground">
            {template.description}
          </p>
        </div>
      </div>

      <div className="mb-4">
        <p className="text-xs text-muted-foreground mb-2">Included Fields:</p>
        <div className="flex flex-wrap gap-2">
          {template.fields.slice(0, 4).map((field, index) => (
            <span
              key={index}
              className="px-2 py-1 bg-muted rounded-sm text-xs text-foreground"
            >
              {field.replace(/([A-Z])/g, ' $1').trim()}
            </span>
          ))}
          {template.fields.length > 4 && (
            <span className="px-2 py-1 bg-muted rounded-sm text-xs text-muted-foreground">
              +{template.fields.length - 4} more
            </span>
          )}
        </div>
      </div>

      <Button
        variant="outline"
        fullWidth
        onClick={() => onGenerate(template.id)}
        iconName="FileText"
        iconPosition="left"
      >
        Generate Report
      </Button>
    </div>
  );
};

export default ReportTemplateCard;